import React from 'react';
import Head from '@dnb/helmet';
import StartPage from '../../components/StartPage/StartPage';

function PageIndex() {
  return (
    <>
      <Head>
        <title>Page Title</title>
      </Head>

      <StartPage />
    </>
  );
}

export default PageIndex;
